const getCurrentGroup = (groups = []) => {
  return groups.reduce(
    (_acc, curr) => {
      return curr.current ? curr : false;
    },
    { current: false }
  );
};

export { getCurrentGroup };
